import { render } from "./IconGrid.vue?vue&type=template&id=027fb3de&scoped=true"
import script from "./IconGrid.vue?vue&type=script&lang=js"
export * from "./IconGrid.vue?vue&type=script&lang=js"

import "./IconGrid.vue?vue&type=style&index=0&id=027fb3de&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-027fb3de"]])

export default __exports__